// Import views
import Homepage from '@/views/Homepage'
import Login from '@/views/Login'
import Register from '@/views/Register'
import Forgot from '@/views/Forgot'
import Reset from '@/views/Reset'
import Dashboard from '@/views/Dashboard'
// Import routes
import CalibersRoutes from '@/routes/calibers.route.js'
import CategoriesRoutes from '@/routes/categories.route.js'
import OrdersRoutes from '@/routes/orders.route.js'
import OrganizationsRoutes from '@/routes/organizations.route.js'
import PostsRoutes from '@/routes/posts.route.js'
import UnitsRoutes from '@/routes/units.route.js'
import ProductsRoutes from '@/routes/products.route.js'
import ReportsRoutes from '@/routes/reports.route.js'
// Other libraries or components
import OrdersPrintReport from '@/reports/orders/Print'
import { i18n } from '@/plugins/i18n'

var importedRoutes = []
importedRoutes = importedRoutes.concat(
    CalibersRoutes,
    CategoriesRoutes,
    OrdersRoutes,
    OrganizationsRoutes,
    PostsRoutes,
    UnitsRoutes,
    ProductsRoutes,
    ReportsRoutes
)

const childrenRoutes = importedRoutes

let routes = [
    {
        path: '/',
        name: 'homepage',
        component: Homepage
    },

    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: i18n.tc('actions.login')
        }
    },

    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            title: i18n.tc('actions.register')
        }
    },

    {
        path: '/forgot',
        name: 'forgot',
        component: Forgot,
        meta: {
            title: i18n.tc('users.lost-password')
        }
    },

    {
        path: '/reset/:userid/:token',
        name: 'reset',
        component: Reset,
        meta: {
            title: i18n.tc('users.reset-password')
        }
    },

    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            authorize: ['ADMIN', 'SUPERUSER', 'USER']
        },
        children: childrenRoutes
    },
    {
        path: '/print',
        name: 'orders-print-report',
        component: OrdersPrintReport,
        props: true,
        meta: {
            title: i18n.tc('general.print'),
            requiresAuth: true,
            authorize: ['ADMIN', 'SUPERUSER', 'USER']
        }
    }
]
export default routes
